define("auth/templates/profile-refresh-popup", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class={{concat-classes "tSU--container" (if this.error "u--text--danger")}}>
    <div class="tSU--card">
      <h1 class="tSU--card__title u--m__b__lg">
        {{#if this.error}}
          {{svg-jar "danger" class="o--icon--lg u--m__r__xs"}}
        {{/if}}
        {{this.messageTitle}}
      </h1>
      <p class="u--text--md">
        {{this.messageBody}}
      </p>
      <Shared::Ui::Button
        @additional="block"
        @class="u--m__t__lg"
        @onClick={{this.onClosePopup}}
        @size="large"
        @text={{t "shared_words.close"}}
        @variant="primary"
      />
    </div>
  </div>
  */
  {
    "id": "lgrAHnG6",
    "block": "[[[10,0],[15,0,[28,[37,0],[\"tSU--container\",[52,[30,0,[\"error\"]],\"u--text--danger\"]],null]],[12],[1,\"\\n  \"],[10,0],[14,0,\"tSU--card\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"tSU--card__title u--m__b__lg\"],[12],[1,\"\\n\"],[41,[30,0,[\"error\"]],[[[1,\"        \"],[1,[28,[35,2],[\"danger\"],[[\"class\"],[\"o--icon--lg u--m__r__xs\"]]]],[1,\"\\n\"]],[]],null],[1,\"      \"],[1,[30,0,[\"messageTitle\"]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n      \"],[1,[30,0,[\"messageBody\"]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,3],null,[[\"@additional\",\"@class\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",\"u--m__t__lg\",[30,0,[\"onClosePopup\"]],\"large\",[28,[37,4],[\"shared_words.close\"],null],\"primary\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"concat-classes\",\"if\",\"svg-jar\",\"shared/ui/button\",\"t\"]]",
    "moduleName": "auth/templates/profile-refresh-popup.hbs",
    "isStrictMode": false
  });
});